import * as types from '../constants/actionTypes';

// http://redux.js.org/docs/advanced/AsyncActions.html
import fetch from 'isomorphic-fetch';

export function requestUserLocation() {
  return {
    type: types.REQUEST_USER_LOCATION
  };
}

export function receiveUserLocation(json) {
  let country_code_2 = json['country_code'];

  return {
    type: types.RECEIVE_USER_LOCATION,
    country_code_2: country_code_2
  };
}

export function fetchLocation() {
  return dispatch => {
    dispatch(requestUserLocation());
    return fetch(`https://climatelist-locator.herokuapp.com/api/country`)
      .then(response => response.json())
      .catch(function(/* error */) {
        // This is the error scenario when fetch fails
        // we force the return to what the geoloc service would have returned for France, so no defaults needed!
        // console.log(error);
        return {'country_code': 'FR'};
      })
      .then(json => dispatch(receiveUserLocation(json))
      );
  };
}

// When default are defined
export function setDefaultCity(from_city_id, from_city_name) {
  return {
    type: types.SET_DEFAULT_CITY,
    from_city_id: from_city_id,
    from_city_name: from_city_name
  };
}

export function setDefaultCurrency(currency_code) {
  return {
    type: types.SET_DEFAULT_CURRENCY,
    currency_code: currency_code
  };
}

// When user makes a choice on the config screen
// We select a city for him
export function customizeLocation(country_code_2, from_city_id, from_city_name) {
  return {
    type: types.CUSTOMIZE_LOCATION,
    country_code_2: country_code_2,
    from_city_id: from_city_id,
    from_city_name: from_city_name
  };
}

export function customizeCurrency(currency_code) {
  return {
    type: types.CUSTOMIZE_CURRENCY,
    currency_code: currency_code
  };
}




/** WEBPACK FOOTER **
 ** ./src/actions/userLocationActions.js
 **/